var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_171)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8094,
    y: 7.73328,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#38A2FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6675 25.3623C40.5409 24.489 41.9757 24.489 42.8491 25.3623C43.7224 26.2357 43.7224 27.6705 42.8491 28.5439C42.3344 29.0585 41.6482 29.2769 40.9464 29.1833C40.9152 29.1833 40.884 29.1833 40.8372 29.1833C40.6345 29.1521 40.4161 29.1833 40.1978 29.2769C39.9014 29.4172 39.6987 29.6512 39.5895 29.9319C39.4804 30.2126 39.496 30.5245 39.6207 30.8053C40.3693 32.4272 40.0262 34.3923 38.7474 35.6556C37.4685 36.9344 35.519 37.2776 33.897 36.529C33.6007 36.3886 33.2888 36.3886 33.0081 36.4978C32.7274 36.6069 32.4934 36.8097 32.3686 37.0904C32.2907 37.2776 32.2439 37.4647 32.2595 37.6675C32.2595 37.6986 32.2595 37.7454 32.2595 37.7766C32.3842 38.494 32.1347 39.227 31.6356 39.7417C30.7623 40.6151 29.3275 40.6151 28.4541 39.7417C28.033 39.3206 27.7991 38.7592 27.7991 38.1509C27.7991 37.5583 28.033 36.9812 28.4541 36.5601C28.9688 36.0455 29.655 35.8271 30.3568 35.9207C30.3724 35.9207 30.3724 35.9207 30.388 35.9207C30.466 35.9363 30.5439 35.9519 30.6219 35.9519C30.7935 35.9519 30.9494 35.9207 31.1054 35.8427C31.4017 35.7024 31.6045 35.4684 31.698 35.2033C31.8072 34.9226 31.8072 34.5951 31.6668 34.2987C30.9182 32.6612 31.2613 30.7117 32.5402 29.4484C33.8191 28.1696 35.7685 27.8265 37.3905 28.5751C37.6712 28.7154 37.9988 28.7154 38.2795 28.6063C38.5602 28.4971 38.7941 28.2943 38.9345 28.0136C39.0437 27.7953 39.0593 27.5457 39.0281 27.3118C38.9189 26.61 39.1528 25.877 39.6675 25.3623ZM37.4373 34.3455C38.4042 33.3786 38.4042 31.8034 37.4373 30.8209C36.4704 29.8539 34.8952 29.8539 33.9126 30.8209C32.9457 31.7878 32.9457 33.363 33.9126 34.3455C34.8952 35.3125 36.4704 35.3125 37.4373 34.3455ZM35.6594 17.5332C43.972 17.5332 50.7094 24.2706 50.7094 32.5832C50.7094 40.8958 43.972 47.6332 35.6594 47.6332C27.3468 47.6332 20.6094 40.8958 20.6094 32.5832C20.6094 24.2706 27.3468 17.5332 35.6594 17.5332ZM43.6756 29.3861C45.0013 28.0604 45.0013 25.9082 43.6756 24.5669C42.35 23.2413 40.1978 23.2413 38.8565 24.5669C38.3575 25.066 38.0611 25.6742 37.9208 26.2981C35.5034 25.3935 32.743 25.9706 30.9026 27.8109C29.0623 29.6512 28.4853 32.4272 29.4054 34.8446C28.766 34.9694 28.1578 35.2813 27.6587 35.7804C26.3331 37.106 26.3331 39.2582 27.6587 40.5995C28.9843 41.9251 31.1366 41.9251 32.4778 40.5995C32.9769 40.1004 33.2888 39.4766 33.4136 38.8371C34.1622 39.1179 34.942 39.2582 35.7218 39.2582C37.4529 39.2582 39.1528 38.5876 40.4161 37.3243C42.2564 35.484 42.8335 32.7392 41.9445 30.3374C42.5683 30.1814 43.1766 29.8695 43.6756 29.3861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_171",
    x: 0.309448,
    y: 0.0332763,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_171"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6094,
    y: 17.5332,
    width: 30.1,
    height: 30.1,
    rx: 15.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelium);
export default __webpack_public_path__ + "static/media/helium.6775b5831848d99797c4f90b578ff5a7.svg";
export { ForwardRef as ReactComponent };